module.exports = "/images/casa.svg";